export default __webpack_public_path__ + "static/media/newtons-second-law.6a083488.jpg";